var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlur(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 14.6406V15.5345H7.42858V14.6406H6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1428 14.6406V15.5345H11.5714V14.6406H10.1428Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42858 15.832H6V16.5769H7.42858V15.832Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 8.68138V7.93652H12.4285V8.68138H13.857Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49854 11.7995V7.125H9.94426L10.2128 7.42294V7.99596H11.5714V7.125L11.2357 6.74512H6.14282V11.7995H7.49854Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 8.97949H12.4285V9.87332H13.857V8.97949Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1428 15.832V16.5769H11.5714V15.832H10.1428Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6085 14.6406V14.7628L16.3228 15.0712H13.8228V14.6406H12.4285V15.5345L17.2231 15.8978L17.9999 15.0712V14.6406H16.6085Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4285 13.6572V14.3425H13.8228V13.9135H16.3285L16.6142 14.1682V14.9065H17.9999V13.9135L17.6599 13.5977H12.4285V13.6572Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 8.89739L11.5714 8.29555V7.93652H10.2128V8.03931L9.94426 8.29555H7.49854V7.93652H6.14282V8.94204L10.9375 8.89739Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.991 13.8979L16.9128 12.7041H12.4285V13.6836L17.991 13.8979Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4285 16.2316V16.5772H13.8228V16.2316H16.3285L16.6142 16.4878V18.5138H17.9999V16.2316L17.2678 15.5763L12.4285 15.4424V16.2316Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49854 9.87263V9.45699H9.94426L10.2128 9.76537V9.87263H11.5714V9.45699L10.8303 8.62012L6.14282 8.9788V9.87263H7.49854Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2543 10.916L11.5714 10.6181V9.83496H10.2128V10.3559L9.94426 10.6181H7.49854V10.1712H6.14282V10.916H11.2543Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1428 13.5977V14.3425H11.5714V13.5977H10.1428Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14282 10.6925V11.8102H10.4857L11.5714 10.6211L6.14282 10.6925Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4463 10.6113L13.527 11.8094H17.4284V10.6113H12.4463Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 6H12.4285V10.5136H13.857V6Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 7.11182L10.5446 6H6.14282V7.11182H11.5714Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57153 18.0664L7.10296 18.5133H10.4687L11.0001 18.0664H6.57153Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 12.96H12.4285V18.5135H13.857V12.96Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.9135V14.3425H7.42858V13.5977H6V13.9135Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4285 10.618H14.3728L13.6785 9.96875L12.4285 10.171V10.618L12.757 10.9159H17.4285V10.618Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4285 7.125V7.63895H13.857V6.74512H12.4285V7.125Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 17.4051V16.8747L10.2143 16.7188L9.62144 17.4051H7.95001L7.25893 16.6562L6 16.8747V17.4051L6.94643 18.5223H10.6518L11.5714 17.4051Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5714 12.7041H10.1428V16.9782H11.5714V12.7041Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 16.875H12.4285V17.7688H13.857V16.875Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42858 12.7041H6V16.9782H7.42858V12.7041Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/Blur.24bb18b93b9d69318256af16e76c9271.svg";
export { ForwardRef as ReactComponent };